export function isDateInThePast(compareDate: Date) {
    const date = new Date(compareDate);
    date.setHours(0, 0, 0, 0);

    const now = new Date(new Date().toISOString());
    now.setHours(0, 0, 0, 0);

    return date < now;
}
